var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0594 0.376695C10.4734 -0.125565 9.52185 -0.125565 8.93591 0.376695L1.43591 6.80563C0.849976 7.30789 0.849976 8.12356 1.43591 8.62582C2.02185 9.12808 2.97341 9.12808 3.55935 8.62582L8.49998 4.38674V16.7142C8.49998 17.4254 9.17029 18 9.99998 18C10.8297 18 11.5 17.4254 11.5 16.7142V4.38674L16.4406 8.6218C17.0265 9.12406 17.9781 9.12406 18.564 8.6218C19.15 8.11954 19.15 7.30387 18.564 6.80161L11.064 0.372677L11.0594 0.376695Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSolid);
export default __webpack_public_path__ + "static/media/arrow-up-solid.72fa42de4583df24aeae06d0c9c23e20.svg";
export { ForwardRef as ReactComponent };